import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  baseUrl = environment.apiUrl + 'Company/';
  baseUrl2 = environment.apiUrl + 'RecordsDLP/';
  baseUrl3 = environment.apiUrl + 'RecordsIRM/';
  baseUrl4 = environment.apiUrl + 'Copilot/';
  baseUrlPrefs = environment.apiUrl + 'UserPreferences/';

  constructor(
    private http: HttpClient,
    private router: Router,
    private _location: Location
  ) {}

  getSecurityBreachesCount({ dateStart, dateEnd }, typeNames?: string[], excludedDomains?: string[]): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);
    if (typeNames?.length) params = params.append('typeNames', typeNames.join(','));
    if (excludedDomains?.length) params = params.append('excludedDomains', excludedDomains.join(','));

    return this.http.get<any>(this.baseUrl2 + 'getSecurityBreachesCount', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params,
    });
  }

  getExternalDeliveryKpiConfig(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrlPrefs + 'externalDeliveryKpiConfig', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
  }

  saveExternalDeliveryKpiConfig(config: any): Observable<any> {
    return this.http.post(this.baseUrlPrefs + 'externalDeliveryKpiConfig', config, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
  }

  getDocumentLebeledCount({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'labeledCountByPeriod', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getIdentifiedAlertsCount({ dateStart, dateEnd }, sensitiveCount?: number, typeNames?: string[]): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);
    if (sensitiveCount != null && sensitiveCount > 0) params = params.append('sensitiveCount', sensitiveCount.toString());
    if (typeNames?.length) params = params.append('typeNames', typeNames.join(','));
    return this.http.get<any>(this.baseUrl2 + 'identifiedAlertsCount', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params,
    });
  }

  getAlertSensitiveTypes(): Observable<HttpResponse<string[]>> {
    return this.http.get<string[]>(this.baseUrl2 + 'alertSensitiveTypes', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
  }

  getAlertKpiConfig(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrlPrefs + 'alertKpiConfig', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
  }

  saveAlertKpiConfig(config: any): Observable<any> {
    return this.http.post(this.baseUrlPrefs + 'alertKpiConfig', config, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
  }

  getTaggingUsersCount({ dateStart, dateEnd }, howAppliedTypes?: string[]): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);
    if (howAppliedTypes?.length) params = params.append('howAppliedTypes', howAppliedTypes.join(','));

    return this.http.get<any>(this.baseUrl3 + 'taggingUsersByPeriod', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTaggingUsersKpiConfig(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrlPrefs + 'taggingUsersKpiConfig', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
  }

  saveTaggingUsersKpiConfig(config: any): Observable<any> {
    return this.http.post(this.baseUrlPrefs + 'taggingUsersKpiConfig', config, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
  }

  getInformationGraphsByCompany({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl2 + 'getInformationGraphsByCompany', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getLabelsGraphByCompany({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'getLabelsBycompany', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopIncidentsUsersByCompany({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl2 + 'getTopIncidentsUsersByCompany', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopDeniedUsersByCompany({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'getTopDeniedUsersByCompany', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTaggingChampion({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'taggingChampion', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getDepartamentLabel({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'departmentLabelsForPeriod', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopLabelsByDept({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl3 + 'topLabelsByDeptForPeriod', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getCopilotInteractionsCount({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl4 + 'interactionCount', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopCopilotUsers({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl4 + 'topUsers', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getTopCopilotInteractionsByDepartment({
    dateStart,
    dateEnd,
  }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl4 + 'interactionsByDepartment', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }

  getInteractionsByWorkload({ dateStart, dateEnd }): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    params = params.append('dateStart', dateStart);
    params = params.append('dateEnd', dateEnd);

    return this.http.get<any>(this.baseUrl4 + 'interactionsByWorkload', {
      observe: 'response',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: params,
    });
  }
}
